import { render, staticRenderFns } from "./BaseBusiness.vue?vue&type=template&id=5792fd0e&scoped=true&"
import script from "./BaseBusiness.vue?vue&type=script&lang=js&"
export * from "./BaseBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5792fd0e",
  null
  
)

export default component.exports